
import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { cn } from '@/lib/utils';

function ActionNode({ data }: { data: any }) {
  return (
    <div className={cn(
      "px-4 py-2 shadow-md rounded-md border-2 border-purple-500 bg-purple-50",
      "min-w-[150px] text-center"
    )}>
      <Handle 
        type="target" 
        position={Position.Top} 
        className="w-3 h-3 bg-purple-500" 
      />
      <div className="font-bold">{data.label}</div>
      <div className="text-xs text-muted-foreground">
        {data.action?.system || 'Set action'}
      </div>
      <Handle 
        type="source" 
        position={Position.Bottom} 
        className="w-3 h-3 bg-purple-500" 
      />
    </div>
  );
}

export default memo(ActionNode);
